export default "__VITE_ASSET__B3PdR9OG__"